import React from 'react';

const CreditCheckIcon = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M2.8125 20.6251V17.945C2.8125 11.2091 8.2207 5.64851 14.9566 5.62508C16.5608 5.61937 18.1502 5.9304 19.6339 6.54032C21.1176 7.15024 22.4662 8.04706 23.6025 9.17935C24.7389 10.3116 25.6405 11.6571 26.2557 13.1386C26.8708 14.6201 27.1875 16.2084 27.1875 17.8126V20.6251C27.1875 20.8737 27.0887 21.1122 26.9129 21.288C26.7371 21.4638 26.4986 21.5626 26.25 21.5626H3.75C3.50136 21.5626 3.2629 21.4638 3.08709 21.288C2.91127 21.1122 2.8125 20.8737 2.8125 20.6251Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 5.625V9.375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 21.5625L19.6875 11.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4375 15.9375H27.0445"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.97534 15.9375H6.56245"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CreditCheckIcon;
